export default "__VITE_ASSET__b5689dde__"